import React from 'react';

export interface NothingToShowProps {
	message: string;
}
export const NothingToShow = ({ message }: NothingToShowProps) => {
	return (
		<div className="nothing-to-show__container">
			<p>{message}</p>
		</div>
	);
};
